import I18n from 'i18n-js'
// import * as RNLocalize from 'react-native-localize'
import vi from './locales/vi'
import ja from './locales/ja'
import en from './locales/en'
import ko from './locales/ko'
// const locales2 = RNLocalize.getLocales()

// const locales = [
//   {countryCode: 'US', languageTag: 'en-US', languageCode: 'en', isRTL: false},
//   {countryCode: 'VN', languageTag: 'vi-VN', languageCode: 'vi', isRTL: false},
// ]

export const setI18nConfig = localeSelect => {
  if (localeSelect) {
    localStorage.setItem('LOCALE', localeSelect)
  } else {
    localStorage.setItem('LOCALE', 'ja')
  }
  let locale = {}
  // let locale = RNLocalize.findBestAvailableLanguage(['en-US', 'vi-VN'])
  if (localeSelect === 'vi') {
    locale = {
      isRTL: false,
      languageTag: 'vi-VN',
    }
  } else if (localeSelect === 'ko') {
    locale = {
      isRTL: false,
      languageTag: 'ko-KR',
    }
  } else if (localeSelect === 'en') {
    locale = {
      isRTL: false,
      languageTag: 'en-US',
    }
  } else {
    locale = {
      isRTL: false,
      languageTag: 'ja-JP',
    }
  }

  I18n.defaultLocale = 'ja-JP'
  I18n.locale = locale.languageTag

  I18n.fallbacks = true
  I18n.translations = {
    vi,
    ja,
    en,
    ko,
  }

  // if (typeof callback === 'function') callback()
}

const defaultLocale = localStorage.getItem('LOCALE')
setI18nConfig(defaultLocale)

export default I18n
